import { useLingui } from '@lingui/react/macro';
import { GoogleLogin } from '@react-oauth/google';
import { type FC, useRef } from 'react';
import { Button } from '@/shared/Button';
import { cn } from '@/shared/react';
import { useVerifyGoogleLogin } from './api';
import googleLogo from './assets/google.png';

export const GoogleLoginButton: FC<{
  className?: string;
  onFinish?: () => void;
}> = ({ className, onFinish }) => {
  const { t } = useLingui();
  const loginRef = useRef<HTMLDivElement>(null);
  const verifyGoogleLogin = useVerifyGoogleLogin();

  return (
    <>
      <Button
        className={className}
        variant="outline"
        size={12}
        type="button"
        loading={verifyGoogleLogin.isMutating}
        onClick={() => {
          const clickableEl =
            loginRef.current?.querySelector<HTMLButtonElement>('[role=button]');
          clickableEl?.click();
        }}
        block
      >
        <img alt="Google Logo" src={googleLogo} className="size-5" />
        {t`Continue with Google`}
      </Button>

      <div ref={loginRef} className="hidden">
        <GoogleLogin
          containerProps={{
            className: cn(
              'w-full [&,&>div,&>div>div,&>div>div>div]:!h-12 [&>div>div>div]:!rounded-xl',
              className,
            ),
          }}
          onSuccess={(res) => {
            if (!res.credential) throw new Error('credential not found!');
            return verifyGoogleLogin
              .trigger({
                id_token: res.credential,
              })
              .then(onFinish);
          }}
          logo_alignment="center"
          shape="rectangular"
          size="large"
          text="continue_with"
          theme="outline"
          type="standard"
          use_fedcm_for_prompt
          width="100%"
        />
      </div>
    </>
  );
};
